export default {
    RECEIVE: 'receive',
    SEND: 'send',
    SEND_CONFIRMATION: 'send-confirmation',
    PRIVATE_KEY: 'private-key',
    DEPOSIT_STAKE: 'deposit-stake',
    DEPOSIT_STAKE_CONFIRMATION: 'deposit-stake-confirmation',
    WITHDRAW_STAKE: 'withdraw-stake',
    WITHDRAW_STAKE_CONFIRMATION: 'withdraw-stake-confirmation',
    SMART_CONTRACT_CONFIRMATION: 'smart-contract-confrimation',
    NETWORK_SELECTOR: 'network-selector',
    GUARDIAN_NODE_DELEGATE_SELECTOR: 'guardian-node-delegate-selector',

    CONFIRM_TRANSACTION: 'confirm-transaction',
    CREATE_TRANSACTION: 'create-transaction',
    DELEGATED_NODE_SELECTOR: 'delegated-node-selector',
    TRACK_TOKEN: 'track-token',
    COLLECTIBLES: 'collectibles',
    TRACK_COLLECTIBLE: 'track-collectible',
    DAPP: 'dapp',
    DAPP_NETWORK: 'dapp-network',
    PERSONAL_SIGN: 'personal-sign',
};
